import { createRoute } from "@tanstack/react-router";

import { RuleEditor } from "@/components/kb/rule-editor";
import { rootRoute } from "./__root";

export const createRuleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/rules/create",
	component: () => <RuleEditor />,
});
